import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import moment from "moment";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {CircleFilledChip, RenewIcon} from "../../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {getDateFormat} from "../../../../../Apis/functions";
import ConnectionStatusApp from "../../../DiningKitchen/Functionality/ConnectionStatusApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const IncomingInvitationStatus = ({ isOnline, setIsReload, item }) => {
    const {
        t,
        hour,
        dateFormat
    } = ConnectionStatusApp();

    return (
        <div className='d-flex flex-wrap'>

            {/* Status */}
            <div className="d-flex align-items-center gap-2 flex-shrink-0">
                <p className="fs-16px ibl-font-w-600 font-color-general-950 mb-0">{t("status") + ":"}</p>
                <CustomUserChip
                    className={`mt-0 mx-0 px-0 text-nowrap ${isOnline ? 'chip-success-150-100' : 'chip-error-code-150-100'}`}
                    variant={'large'}
                    Icon={CircleFilledChip}
                    showAvatar={true}
                    name={isOnline ? "online" : "offline"}
                    iconPosition={POSITION_MODEL.LEFT}
                    classNameIcon={`icon-color-primary-700`}
                />
            </div>

            {/* Renew button */}
            <div className={`icon-color-shades-400 w-40px h-24px flex-shrink-0 ${isOnline ? 'cursor-not-allowed' : 'cursor-pointer icon-hover-shades-950'}`}>
                <CustomTooltip text={!isOnline && t('renew')}>
                    <RenewIcon
                        width={40}
                        height={24}
                        onClick={() => setIsReload(prev => prev + 1)}
                    />
                </CustomTooltip>
            </div>

            <div className={"flex-grow-1 minw-0"}>
                <p className={"fs-20px ibl-font-w-400 font-color-general-950 text-capitalize"}>{dateFormat} <span className={"w-100px text-center"}>{getDateFormat(hour, false, 'HH:mm:ss')}</span></p>
            </div>
        </div>
    );
};


export default IncomingInvitationStatus
